import { useTranslation } from '@eti/providers';
import { useRef } from 'react';
import { useLinksAccessibility } from '../../custom-hooks/useLinkAccessibility';
import { useProductSnowplowTracking } from '../../custom-hooks/useProductSnowplowTracking';
import getTranslatedTexts from '../../common/text-resolvers/utils/getTranslatedTexts';
import SingleChoice from '../../single-choice/containers/SingleChoiceContainer';
import { CONNECTION_GUARANTEE } from '../../products';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  name: PRODUCT_NAME,
  id: PRODUCT_ID
} = CONNECTION_GUARANTEE;
export const texts = {
  persuasionContent: 'connectionGuaranteePersuasionContent',
  upSell: 'connectionGuaranteeUpSellText',
  additionalInformation: 'connectionGuaranteeAdditionalInformation',
  readMoreContent: 'connectionGuaranteeReadMoreModalContent',
  text: 'connectionGuaranteeAbstract',
  title: 'connectionGuaranteeTitle'
};
const ConnectionGuarantee = _ref => {
  let {
    className,
    confirmText,
    declineText,
    form,
    hasLogo,
    isNeutral,
    persuasion,
    pricePerTravelerRaw,
    shouldShowImage,
    shouldShowMandatoryChoiceText,
    order,
    productPosition
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    additionalInformation,
    persuasionContent,
    readMoreContent,
    text,
    title,
    upSell
  } = getTranslatedTexts(texts, t);
  const rootElement = useRef(null);
  useProductSnowplowTracking(PRODUCT_NAME, {
    rootElement,
    productPosition
  });
  useLinksAccessibility({
    targetElement: rootElement,
    productTitle: title
  });
  return /*#__PURE__*/_jsx("div", {
    ref: rootElement,
    children: /*#__PURE__*/_jsx(SingleChoice, {
      additionalInformation: additionalInformation,
      className: className,
      confirmText: confirmText,
      declineText: declineText,
      form: form,
      hasLogo: hasLogo,
      isNeutral: isNeutral,
      order: order,
      persuasion: persuasion,
      persuasionContent: persuasionContent,
      pricePerTravelerRaw: pricePerTravelerRaw,
      productId: PRODUCT_ID,
      productName: PRODUCT_NAME,
      productPosition: productPosition,
      readMoreContent: readMoreContent,
      rootElement: rootElement,
      shouldShowImage: shouldShowImage,
      shouldShowMandatoryChoiceText: shouldShowMandatoryChoiceText,
      text: text,
      title: title,
      typename: "none",
      upSell: upSell
    })
  });
};
export default ConnectionGuarantee;
//# sourceMappingURL=ConnectionGuarantee.js.map